import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  controlDataService,
  controlSharedModelService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
  actionIcon,
  editControlTypeDialog,
} from 'app/components/global';

import deleteControlTypeConfirmDialog from '../dialog.deleteControlTypeConfirmDialog';
import controller from './control-type.controller';
import directive from './control-type.directive';

const controlTypeAdminModule = angular.module('app.components.admin.controlType', [
  alerts,
  actionIcon,
  confirmDialog,
  editControlTypeDialog,
  deleteControlTypeConfirmDialog,
  loaderService,
  ssDialogService,
  controlDataService,
  controlSharedModelService,
])
  .directive('controlType', directive)
  .controller('ControlTypeController', controller);

export default controlTypeAdminModule.name;

console.log('app.components.admin.controlType created');
